export default __webpack_public_path__ + "static/media/Mark-4-HUD-Pop-Up (2 Layers).578a11ea.jpg";